import React, { ReactElement } from 'react';
import { publicSessionApi } from '../../../../../../redux/views/session-view/session/api/publicApi';
import { ActionsBarCenterContainerProps } from './container';
import { ActionsBarCenter } from '.';

type ConnectedPublicActionsBarCenterProps = ActionsBarCenterContainerProps &
  FetchPublicSessionArgs;

export function ConnectedPublicActionsBarCenter({
  setLeftPanelType,
  setShowEndSessionModal,
  setShowRenameSessionModal,
  setShowResetSessionModal,
  setShowSaveAndEndSessionModal,
  isSessionExpired,
  accessKey,
  sessionUid,
  versionUid,
  isSessionActiveTabTopology,
}: ConnectedPublicActionsBarCenterProps): ReactElement {
  const { actions, data, isError, isLoading } =
    publicSessionApi.endpoints.getPublicSession.useQueryState(
      {
        accessKey,
        sessionUid,
        versionUid,
      },
      {
        selectFromResult: ({ data, isLoading, isError }) => ({
          actions: data?._links,
          data: data?.sessionDetails,
          isError,
          isLoading,
        }),
      },
    );

  return (
    <ActionsBarCenter
      actions={actions}
      setLeftPanelType={setLeftPanelType}
      setShowEndSessionModal={setShowEndSessionModal}
      setShowRenameSessionModal={setShowRenameSessionModal}
      setShowResetSessionModal={setShowResetSessionModal}
      setShowSaveAndEndSessionModal={setShowSaveAndEndSessionModal}
      isSessionExpired={isSessionExpired}
      sessionDetails={data}
      isSessionDetailsLoading={isError || isLoading}
      isSessionActiveTabTopology={isSessionActiveTabTopology}
    />
  );
}
